// AGC: Proposal Summary Dashboard Widget
// AGC: Shows active proposals and voting stats on Home page

import React from 'react'
import { Vote, ArrowRight, Clock, CheckCircle } from 'lucide-react'

interface ProposalSummaryProps {
  onViewDetails: () => void
}

export const ProposalSummary: React.FC<ProposalSummaryProps> = ({ onViewDetails }) => {
  // AGC: TODO: Fetch real proposal data from contract
  const proposalData = {
    activeProposals: 0,
    totalProposals: 0,
    passedProposals: 0,
    yourVotes: 0,
  }

  return (
    <div className="bg-slate-800/50 rounded-xl p-5 border border-slate-700/50">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-white font-semibold flex items-center gap-2">
          <Vote className="w-5 h-5 text-blue-400" />
          Governance Overview
        </h3>
        <button
          onClick={onViewDetails}
          className="text-xs text-blue-400 hover:text-blue-300 flex items-center gap-1"
        >
          View All Proposals <ArrowRight className="w-3 h-3" />
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        <div className="bg-slate-700/50 rounded-lg p-3 text-center">
          <div className="flex items-center justify-center gap-1 text-yellow-400 mb-1">
            <Clock className="w-4 h-4" />
          </div>
          <p className="text-2xl font-bold text-white">{proposalData.activeProposals}</p>
          <p className="text-xs text-slate-400">Active</p>
        </div>
        <div className="bg-slate-700/50 rounded-lg p-3 text-center">
          <div className="flex items-center justify-center gap-1 text-[#0072CE] mb-1">
            <CheckCircle className="w-4 h-4" />
          </div>
          <p className="text-2xl font-bold text-white">{proposalData.passedProposals}</p>
          <p className="text-xs text-slate-400">Passed</p>
        </div>
        <div className="bg-slate-700/50 rounded-lg p-3 text-center">
          <p className="text-2xl font-bold text-white">{proposalData.totalProposals}</p>
          <p className="text-xs text-slate-400">Total</p>
        </div>
        <div className="bg-slate-700/50 rounded-lg p-3 text-center">
          <p className="text-2xl font-bold text-blue-400">{proposalData.yourVotes}</p>
          <p className="text-xs text-slate-400">Your Votes</p>
        </div>
      </div>

      {proposalData.activeProposals === 0 ? (
        <div className="mt-4 pt-4 border-t border-slate-700/50 text-center">
          <p className="text-slate-500 text-sm">No active proposals</p>
          <p className="text-slate-600 text-xs mt-1">Check back later for new governance votes</p>
        </div>
      ) : (
        <div className="mt-4 pt-4 border-t border-slate-700/50">
          <button
            onClick={onViewDetails}
            className="w-full py-2 bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 rounded-lg text-sm font-medium transition-colors"
          >
            Vote on Active Proposals
          </button>
        </div>
      )}
    </div>
  )
}

